let language = {
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_PRICE: "Price:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ITEM_TOTAL: "Total:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_ORDER_NUMBER: "Orders",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_QTY: "Qty",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_TOTAL_PRICE: "Total Price",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_STORE_NAME: "Store",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_HEADER_UNIT_PRICE: "Unit Price:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_SUBTOTAL: "Subtotal:",


    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_TITLE:"Total Price Details",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_UNIT_PRICE:"Unit Price Details",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_ORIGINAL_PRICE: "Original price:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_COMBINE_DISCOUNT: "Combine order discount:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_COUPON_DISCOUNT: "Coupon discount:",
    BULK_ORDER_CHECKOUT_STEP_PRODUCT_ORDER_POPOVER_DISCOUNTED_PRICE: "Discount price:",
};

export { language }